// Generated by Melange

import * as Buhta_core__GlobalStateContext from "../../../../../../packages/core/lib/GlobalStateContext.js";
import * as Buhta_landing__ButtonPrimary from "../../../components/landing/ButtonPrimary.js";
import * as Buhta_landing__EventHandlers from "../../../util/EventHandlers.js";
import * as Buhta_landing__I18n from "../../../util/i18n/I18n.js";
import * as Cn from "../../../../../../vendored/classnames/Cn.js";
import * as StaticAsset from "../../../../../../packages/util/lib/StaticAsset.js";
import * as ReactIntl from "react-intl";
import * as JsxRuntime from "react/jsx-runtime";

function KassaIntro(Props) {
  const state = Buhta_core__GlobalStateContext.useGlobalState(undefined);
  const deviceType = state.deviceType;
  const intl = ReactIntl.useIntl();
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx("h1", {
        children: "Технологичная фискализация без ошибок",
        className: "h3 lg:h1 text-center lg:flex lg:m-auto text-white lg:w-220"
      }),
      JsxRuntime.jsx(Buhta_landing__ButtonPrimary.make, {
        classes: {
          hd: "flex m-auto mt-6",
          tl: /* [] */ 0
        },
        label: Buhta_landing__I18n.trans(intl, "start_using"),
        onClick: (function (param) {
          Buhta_landing__EventHandlers.scrollToFooter(deviceType);
        })
      }),
      JsxRuntime.jsx("hr", {
        className: "flex m-auto mt-16 lg:w-200 opacity-8 text-white"
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsxs("span", {
            children: [
              JsxRuntime.jsx("img", {
                className: "inline mr-3",
                alt: "cash",
                src: StaticAsset.src("/static/icons/cash.svg")
              }),
              "Автоматические смены"
            ],
            className: "paragraph-small text-white block lg:inline mt-4 lg:mt-0 first:mt-0 ml-0"
          }),
          JsxRuntime.jsxs("span", {
            children: [
              JsxRuntime.jsx("img", {
                className: "inline mr-3",
                alt: "cashier",
                src: StaticAsset.src("/static/icons/cashier.svg")
              }),
              "Отправка чеков покупателю"
            ],
            className: "paragraph-small text-white block lg:inline mt-4 lg:mt-0 lg:ml-14 first:mt-0"
          }),
          JsxRuntime.jsxs("span", {
            children: [
              JsxRuntime.jsx("img", {
                className: "inline mr-3",
                alt: "bag",
                src: StaticAsset.src("/static/icons/bag-alt.svg")
              }),
              "Интеграция с вашим сайтом"
            ],
            className: "paragraph-small text-white block lg:inline mt-4 lg:mt-0 lg:ml-14 first:mt-0"
          })
        ],
        className: "text-left lg:text-center mt-8 block lg:flex justify-center"
      }),
      JsxRuntime.jsx("div", {
        children: JsxRuntime.jsx("img", {
          className: "lg:h-145 lg:w-252",
          alt: "kassa",
          src: StaticAsset.src("/static/images/kassa.png")
        }),
        className: "flex m-auto mt-10 lg:mt-16 max-h-52.75 sm:max-h-none lg:w-252"
      }),
      JsxRuntime.jsx("h3", {
        children: "Автоматизируйте процесс выдачи чека",
        className: "h3 lg:h2 text-center flex m-auto mt-26 lg:mt-70 text-white lg:w-146.25"
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx("img", {
                className: "m-auto",
                alt: "website",
                src: StaticAsset.src("/static/images/website.svg")
              }),
              JsxRuntime.jsx("h4", {
                children: "Интеграция с вашим сайтом",
                className: "h4 text-white mt-6 lg:mt-8"
              }),
              JsxRuntime.jsx("p", {
                children: "Простая интеграция с вашим сайтом позволит настроить фискализацию продаж очень быстро и просто.",
                className: "paragraph text-white opacity-40 mt-2"
              })
            ],
            className: "lg:w-78.75 lg:px-6 text-center"
          }),
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx("img", {
                className: "m-auto",
                alt: "cheque",
                src: StaticAsset.src("/static/images/cheque.svg")
              }),
              JsxRuntime.jsx("h4", {
                children: "Продажи с выдачей чека",
                className: "h4 text-white mt-6 lg:mt-8"
              }),
              JsxRuntime.jsx("p", {
                children: "Ваши покупатели после покупки будут автоматически получать чеки удобным способом, что сделает покупки проще и приятнее.",
                className: "paragraph text-white opacity-40 mt-2"
              })
            ],
            className: "mt-8 lg:mt-0 lg:w-78.75  lg:px-6 text-center"
          }),
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx("img", {
                className: "m-auto",
                alt: "auto cheque",
                src: StaticAsset.src("/static/images/auto-cheque.svg")
              }),
              JsxRuntime.jsx("h4", {
                children: "Автоматическая выдачa чека",
                className: "h4 text-white mt-6 lg:mt-8"
              }),
              JsxRuntime.jsx("p", {
                children: "При продаже товаров и услуг в интернете с использованием карт должен обязательно выдаваться фискальный чек.",
                className: "paragraph text-white opacity-40 mt-2"
              })
            ],
            className: "mt-8 lg:mt-0 lg:w-78.75  lg:px-6 text-center"
          })
        ],
        className: Cn.fromList({
          hd: "lg:flex lg:m-auto mt-10 lg:mt-16 justify-between lg:w-252",
          tl: /* [] */ 0
        })
      })
    ],
    className: "bg-black-landing pt-16 pb-30 px-6 lg:pt-40 sm:px-48 lg:px-0"
  });
}

const make = KassaIntro;

export {
  make,
}
/* Buhta_core__GlobalStateContext Not a pure module */
